import { LOCALES_TO_LANGUAGE } from "@Context/TranslationContext/TranslationContext";
import { getTranslations } from "@Utils/translations";

export const getLocalisedAltText = (symbol: string, locale: "de-CH" | "rm") => {
  const translations = getTranslations(LOCALES_TO_LANGUAGE[locale]);

  return (translations.symbol as { [key: string]: string })[symbol] ?? "";
};
